import { render, staticRenderFns } from "./CurrentFlexPropsSchema.vue?vue&type=template&id=06d445e9&"
import script from "./CurrentFlexPropsSchema.vue?vue&type=script&lang=js&"
export * from "./CurrentFlexPropsSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports